import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 89,
  label: "主分类申请人分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "primaryIpc", label: "主分类", limit: 10, needTotal: true }],
    colDims: [
      {
        name: "applicantNewName",
        label: "申请人",
        table: "patent_applicant",
        limit: 10,
        needTotal: true,
      },
    ],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    showNoDataDims: true,
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "主分类申请人分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false,
  },
};
